<template>
  <footer id="footer" class="dark noborder nomargin">
    <div id="copyrights">
      <div class="container clearfix">
        <div class="col_half">
          <div class="copyright-links">
            <a href="https://www.forhair.co.kr/membership/privacy-policy.asp"
              >개인정보취급방침</a
            >
            /
            <a
              href="https://www.forhair.co.kr/membership/terms-and-conditions.asp"
              >이용약관</a
            >
            <br />
              {{ $t('forhairmedical') }} (tel: 1599-4005) <br />
              대표 : 권오성&nbsp;|&nbsp;사업자번호 : 617-36-43539
          </div>
        </div>

        <div class="col_half col_last tright">
          <i class="icon-envelope2"></i> admin@forhair.co.kr
          <span class="middot">&middot;</span>
          <i class="icon-headphones"></i> +82-1599-4005 
          {{ $t('branchgangnamaddr') }}
          <!-- 서울시 서초구 서초대로
          77길 54 서초 더블유타워 4층 -->
        </div>
      </div>
    </div>
    <!-- #copyrights end -->
  </footer>
  <!-- #footer end -->
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
